module.exports = __webpack_public_path__ + "static/img/kedi.e64a3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kedi.png
// module id = 5NFO
// module chunks = 1